import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=537c10c2&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./Landing.vue?vue&type=style&index=0&id=537c10c2&scoped=true&lang=css&"
import style1 from "./Landing.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537c10c2",
  null
  
)

export default component.exports